import React from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Button from '@material-ui/core/Button';
import UploadDocumentButton from '../UploadDocumentButton';
import {downloadDocument, getDocumentV2FromFile, validateDocument, convertBufferedMessageToString} from '../../shared/documentUtil';
import {actionCreators as selfServiceActionCreators} from '../../redux/actions/selfServiceActions';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

const IdentificationDocumentActions = (props) => {
	const {
		document,
		documentType,
		documentName,
		allowRemoveDocument,
		allowAddDocument,
		addIdentificationDocumentFile,
		deleteIdentificationDocument,
		showSnackBar,
		isInScopeDocument,
		setFieldError
	} = props;
	const documentsSettings = useSelector((state) => state.staticData.documentSettings);
	const dispatch = useDispatch();
	const allParams = useParams();

	const addNewIdentificationDocumentFile = (docV2) => {
		const docToBeAdded = {
			BaseDocumentId: docV2.BaseDocumentId,
			FileName: docV2.DocumentName,
			FileExtension: docV2.Extension,
			UploadedFileName: docV2.UploadedFileName,
		};
		addIdentificationDocumentFile(docToBeAdded);
	};

	const handleSave = async (fileUploaded) => {
		const error = validateDocument(fileUploaded, documentsSettings);
		if (!error) {
			const docV2 = await saveDocument(documentType, documentName, fileUploaded);
			if (docV2) {
				addNewIdentificationDocumentFile(docV2);
			}
		} else {
			setFieldError(error);
		}
	};

	const saveDocument = async (documentType, documentName, fileUploaded) => {
		setFieldError(null);
		const docV2 = await getDocumentV2FromFile(documentType, documentName, fileUploaded, documentName);
		const response = await dispatch(selfServiceActionCreators.uploadIdentificationDocument(allParams.entityId, docV2));

		if(response.requestError) {
			setFieldError(mapResponseToError(response.requestError));

			return null;
		}
		else {
			return {...docV2, BaseDocumentId: response.data};
		}
	};

	const removeFile = async () => {
		setFieldError(null);
		const response = await dispatch(selfServiceActionCreators.deleteIdentificationDocument(allParams.entityId, document.BaseDocumentId));

		if(response.requestError) {
			setFieldError(mapResponseToError(response.requestError));
		}
		else {
			deleteIdentificationDocument();
		}
	};

	const downloadFile = async () => {
		setFieldError(null);
		const response = await dispatch(
			selfServiceActionCreators.requestIdentificationDocument(allParams.entityId, document.BaseDocumentId)
		);

		if(response.requestError) {
			setFieldError(mapResponseToError(response.requestError));
		}
		else {
			downloadDocument(response);
		}
	};

	const mapResponseToError = (requestError) => {
		var data = requestError.response.data;

		return data.ErrorMessage ? data.ErrorMessage : data;
	}

	const buttonStyle = { width: `33%` };
	const hideButtonStyle = { display: `none` };

	return (
		<div style={{display:`flex`, flexDirection: 'row', width: '100%'}}>
			<div style={{display: `flex`, width: `100%`}}>
				<div style={isInScopeDocument ? hideButtonStyle: buttonStyle}>
					<UploadDocumentButton
						disabled={!allowAddDocument}
						validateDocument={(file) => {
							return validateDocument(file, documentsSettings);
						}}
						handleSave={handleSave}
					/>
				</div>
				<div style={isInScopeDocument ? hideButtonStyle: buttonStyle}>
					<Button
						// style={{width: 200, margin:10}}
						disabled={!allowRemoveDocument}
						variant='contained'
						color='secondary'
						size='small'
						onClick={removeFile}
						startIcon={<DeleteIcon />}
					>
						Remove File
					</Button>
				</div>
				<div style={{ width: `33%` }}>
					<Button
						// style={{width: 200, margin:10}}
						disabled={!document}
						onClick={downloadFile}
						variant='contained'
						color='primary'
						size='small'
						startIcon={<CloudDownloadIcon />}
					>
						Download File
					</Button>
				</div>
			</div>

			{!isInScopeDocument && document && (<small>File Name: {document.UploadedFileName}</small>)}
		</div>
	);
};
export default IdentificationDocumentActions;
